import { Divider } from '@mui/material';
import { t } from 'i18next';
import React from 'react';
import InventorySection from 'src/components/dashboardComponents/InventorySection';
import OperatorSubOrderSection from 'src/components/dashboardComponents/OperatorSubOrderSection';

const OperatorDashboard = () => {
  const tomorrow = new Date();
  tomorrow.setDate(tomorrow.getDate() + 1);
  return (
    <>
      <InventorySection />
      <Divider sx={{ mb: 4 }} />
      <OperatorSubOrderSection status={'IN_PROGRESS'} title={t('dashboard.inProgressTitle')} />
      <Divider sx={{ mb: 4 }} />
      <OperatorSubOrderSection status={'PREPARING'} title={t('dashboard.preparingTitle')} />
      <Divider sx={{ mb: 4 }} />
      <OperatorSubOrderSection status={'READY_FOR_DISPATCHED'} title={t('dashboard.RFDTitle')} />
      <Divider sx={{ mb: 4 }} />
      <OperatorSubOrderSection
        date={tomorrow.toISOString()}
        status={'IN_PROGRESS'}
        title={t('dashboard.deliveryTomorrow')}
      />
      <div style={{ marginBottom: '1.5rem' }}></div>
    </>
  );
};

export default OperatorDashboard;
